import { MENU_SCROLLED_TOP_POSITION } from 'hb-react/frontoffice/apps/Menu/constants';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import useScrollPosition from 'hb-react/shared/hooks/useScrollPosition';

// FO Header can have a background color defined in the BO by admin, and this value can change once scrolled
// FO header can have (icons) color defined in the BO by admin, and this value can change once scrolled
const useHeaderTheme = ({ network } = {}) => {
  const scrollPosition = useScrollPosition();
  const { currentNetwork } = useDefaultAppContexts();

  const networkData = network || currentNetwork;

  // Header changes on scroll
  if (networkData?.theming?.fo?.fo_main_navigation_change_on_scroll) {
    // The page is scrolled
    if (scrollPosition > MENU_SCROLLED_TOP_POSITION) {
      return {
        color: networkData?.theming?.fo?.fo_header_scrolled_color,
        backgroundColor:
          networkData?.theming?.fo?.fo_header_scrolled_background_color,
      };
    }

    // The page is not scrolled / at top
    return {
      color: networkData?.theming?.fo?.fo_header_static_color,
      backgroundColor:
        networkData?.theming?.fo?.fo_header_static_background_color,
    };
  }

  // Menu doesn't change on scroll
  return {
    color: networkData?.theming?.fo?.fo_header_static_color,
    backgroundColor:
      networkData?.theming?.fo?.fo_header_static_background_color,
  };
};

export default useHeaderTheme;
